module.exports = __webpack_public_path__ + "static/media/scroll4_phone2_2x.1a0f5491.png";